import httpService from '@/core/http/http.service';
import siteContextStore from '@/shared/content/site-context.store';

const getCurrentLanguage = () => siteContextStore.settings.language.toLowerCase();

export class TempSearchApiClient {
    private readonly baseUrl: string = '';

    search(term: string, size: number = 8): Promise<TempSearchViewModel> {
        const apiUrl = `${this.baseUrl}/api/search?includerangelimits=false&language=${getCurrentLanguage()}&mode=search&size=${size}`;
        return httpService.get<TempSearchViewModel>(apiUrl, { term });
    }
}

export const TempSearchApiClientService = new TempSearchApiClient();

export type TempSearchViewModel = any;
